import FrameFaq from './frame'

document.querySelectorAll<HTMLElement>('.frame.faq').forEach((el) => {
	new FrameFaq(el).init()
})
